import React from 'react';
import Wrapper from '../wrapper/Wrapper';
import * as tableHeader from './factory/activityHeader';
import TableComponent from 'component/molecules/Table/TableComponent';
import { userEndpoints } from 'hooks/endpoints';
const Activity = ({ userId }) => {
  return (
    <Wrapper>
      <TableComponent
        headerData={tableHeader.headerData}
        noPadding
        api={{
          get: {
            url: userEndpoints.getActivitiesById,
            params: { UserId: userId },
          },
        }}
      />
    </Wrapper>
  );
};

export default Activity;
